import { render, staticRenderFns } from "./SoccerCardSvg.vue?vue&type=template&id=50cc89e2&"
import script from "./SoccerCardSvg.vue?vue&type=script&lang=ts&"
export * from "./SoccerCardSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports